import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-CercacasaNearbyAddress" */'@modals/partials/cerca-casa/NearbyAddress'));
